import React, { Component } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./css/engagementsec.css";
import Engagcard from "./engagcard";
import { API_BASE_URL, authHeaders } from "../api";

class EngagSec extends Component {

    constructor(props) {
        super(props);

        const width = window.innerWidth;

        let itemsPerView = 3;

        if (width <= 768) {
            itemsPerView = 1;
        } else if (width <= 1280) {
            itemsPerView = 2;
        }

        this.state = {
            items: [],
            startIndex: 0,
            itemsPerView: itemsPerView,
            touchStartX: null
        };
    }

    async loadCV() {
        try {
            const res = await fetch(`${API_BASE_URL}/api/engagement`, {
                headers: authHeaders()
            });

            const data = await res.json();

            this.setState({ items: data });

        } catch (err) {
            console.error("Error loading CV:", err);
        }
    }

    componentDidMount() {
        this.loadCV();
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        const width = window.innerWidth;
        const itemsPerView = width <= 768 ? 1 : width <= 1280 ? 2 : 3;

        this.setState((state) => ({
            itemsPerView,
            startIndex: Math.min(state.startIndex, Math.max(state.items.length - itemsPerView, 0))
        }));
    };

    handleTouchStart = (event) => {
        this.setState({ touchStartX: event.touches[0].clientX });
    };

    handleTouchEnd = (event) => {
        if (this.state.touchStartX === null) return;

        const diff = this.state.touchStartX - event.changedTouches[0].clientX;

        if (Math.abs(diff) > 45) {
            diff > 0 ? this.next() : this.prev();
        }

        this.setState({ touchStartX: null });
    };

    goTo = (index) => {
        const maxIndex = Math.max(this.state.items.length - this.state.itemsPerView, 0);

        this.setState({
            startIndex: Math.max(0, Math.min(index, maxIndex))
        });
    };

    next = () => {
        if (this.state.startIndex + this.state.itemsPerView < this.state.items.length) {
            this.setState({ startIndex: this.state.startIndex + 1 });
        }
    };

    prev = () => {
        if (this.state.startIndex > 0) {
            this.setState({ startIndex: this.state.startIndex - 1 });
        }
    };

    render() {

        const maxIndex = Math.max(this.state.items.length - this.state.itemsPerView, 0);
        const canGoBack = this.state.startIndex > 0;
        const canGoForward = this.state.startIndex < maxIndex;
        const slideWidth = 100 / this.state.itemsPerView;
        const trackStyle = {
            transform: `translateX(-${this.state.startIndex * slideWidth}%)`
        };

        return (
            <div className="EngagSec-wrapper">

                <button
                    className="nav-btn left"
                    onClick={this.prev}
                    disabled={!canGoBack}
                    aria-label="Vorherige Engagements"
                >
                    <ChevronLeft size={22} />
                </button>

                <div
                    className="EngagSec-viewport"
                    onTouchStart={this.handleTouchStart}
                    onTouchEnd={this.handleTouchEnd}
                >
                    <div className="EngagSec-track" style={trackStyle}>
                        {this.state.items.map((item) => (
                            <div
                                className="EngagSec-slide"
                                style={{ flexBasis: `${slideWidth}%` }}
                                key={item.id}
                            >
                                <Engagcard
                                    title={item.title}
                                    description={item.description}
                                    image={item.image}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    className="nav-btn right"
                    onClick={this.next}
                    disabled={!canGoForward}
                    aria-label="Nächste Engagements"
                >
                    <ChevronRight size={22} />
                </button>

                <div className="EngagSec-dots" aria-label="Engagement Navigation">
                    {Array.from({ length: maxIndex + 1 }).map((_, index) => (
                        <button
                            type="button"
                            key={index}
                            className={index === this.state.startIndex ? "active" : ""}
                            onClick={() => this.goTo(index)}
                            aria-label={`Engagement Seite ${index + 1}`}
                        />
                    ))}
                </div>

            </div>
        );
    }
}

export default EngagSec;
